import React from 'react';

import { Newsletter } from '../../components';
import {FiFacebook, FiTwitter, FiInstagram} from 'react-icons/fi'
import './Footer.css';
import { images } from '../../constants';

const Footer = () => (
  <div className="app__footer section__padding" id='contact'>
    {/* <FooterOverlay/> */}
    <Newsletter />
    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">1845 Prospect St, Pretoria, Gauteng, South Africa</p>
        <p className="p__opensans">+254 700 222 333</p>
        <p className="p__opensans">+254 780 282 383</p>
      </div>

      <div className="app__footer-links_logo">
        <img src={images.gericht} alt="Company Logo" />
        <p className="p__opensans">"The best way to find yourself is to lose yourself in the service of others"</p>
        <img src={images.spoon} alt="spoon" style={{ marginTop: '50px' }} />
        <div className="app__footer-links_icons">
          <FiFacebook />
          <FiTwitter />
          <FiInstagram/>
        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Working Hours</h1>
        <p className="p__opensans">Monday - Friday:</p>
        <p className="p__opensans">10am To 12am</p>
        <p className="p__opensans">Saturday - Sunday:</p>
        <p className="p__opensans">11am To 9pm</p>
      </div>
    </div>

    <div className="app__footer-backToTop">
      <a href="#header" className='p__opensans'>Back To Top</a>
    </div>

    <div className="footer__copyright">
      <p className="p__opensans">&copy; 2022 Gericht Restaurant. All Rights Reserved</p>
    </div>
  </div>
);

export default Footer;
